document.addEventListener("DOMContentLoaded", function () {
  // Function to handle mouseover on multicolumn list items
  function handleMouseOver() {
    const items = document.querySelectorAll(".multicolumn-list__item");
    items.forEach((item) => {
      item.addEventListener("mouseover", () => {
        items.forEach((i) => i.classList.remove("active"));
        item.classList.add("active");
      });
    });
  }

  // Function to hide swipe icon on interaction
  function hideSwipeIconOnInteraction() {
    const swipeIcon = document.getElementById("swipe-icon");
    const videoContainer = document.querySelector(".multicolumn-list");

    if (!swipeIcon || !videoContainer) {
      console.error(
        "Required elements not found. Make sure 'swipe-icon' and '.multicolumn-list' exist in the DOM."
      );
      return;
    }

    function hideSwipeIcon() {
      const swipeIcon = document.getElementById("swipe-icon");
      const clonedIcons = document.querySelectorAll(".swipe-icon-clone");

      // Remove the original swipe icon if it exists
      if (swipeIcon) {
        swipeIcon.remove();
      }

      // Remove all cloned swipe icons with additional check
      clonedIcons.forEach((clone) => {
        if (clone.parentNode) {
          clone.parentNode.removeChild(clone); // Ensure the parent node exists and remove the clone
        }
        clone.remove();
      });
    }

    videoContainer.addEventListener("scroll", hideSwipeIcon);
    swipeIcon.addEventListener("scroll", hideSwipeIcon);
  }
  function showSwipeIcon() {
    const button = document.getElementById("swipe-icon");
    const buttonClone = document.getElementById("swipe-icon-clone");
  
    if (!button) {
      console.error("Button with ID 'swipe-icon' not found.");
      return;
    }
  
    if (window.innerWidth <= 768) {
      const multicolumnList = document.querySelector(".multicolumn-list");
      if (!multicolumnList || multicolumnList.children.length < 2) {
        console.error("Multicolumn list or its children not found.");
        return;
      }
  
      const firstLi = multicolumnList.children[0];
      const secondLi = multicolumnList.children[1];
  
      // Remove any previously cloned buttons to avoid duplicates
      const existingClones = document.querySelectorAll(".swipe-icon-clone");
      existingClones.forEach((clone) => clone.remove());
  
      // Append the original button to the first list item
      firstLi.appendChild(button);
  
      // Clone the button and append it to the second list item
      const button2 = button.cloneNode(true);
      button2.id = ""; // Remove ID from cloned element to avoid duplicates
      button2.classList.add("swipe-icon-clone"); // Assign a class for easy identification
      secondLi.appendChild(button2);
  
      // Add the necessary classes for styling
      button.classList.add("swipe-icon");
      button.classList.remove("swipe-icon-hidden");
      button2.classList.add("swipe-icon-clone");
      button2.classList.remove("swipe-icon-hidden");
    } else {
      if (buttonClone) {
        buttonClone.classList.add("swipe-icon-hidden");
        buttonClone.classList.remove("swipe-icon-clone");
      }
      button.classList.add("swipe-icon-hidden");
      button.classList.remove("swipe-icon");
    }
  }

  // Call the function to set up the event listeners
  document.addEventListener("DOMContentLoaded", hideSwipeIconOnInteraction);

  // Function to handle slideshow navigation and arrow color updates
  function handleSlideshowNavigation() {
    let slideIndex = 1;
    const slides = document.getElementsByClassName("slideshow-section");
    const prevBtn = document.getElementById("prev-btn");
    const nextBtn = document.getElementById("next-btn");
    const prevSvgPath = document.querySelector("#prev-svg path");
    const nextSvgPath = document.querySelector("#next-svg path");

    if (slides.length === 0) {
      // If no slides, disable both buttons and set arrows to grey
      if (prevBtn && prevSvgPath) {
        prevBtn.classList.add("disabled");
        prevSvgPath.setAttribute("fill", "#4d4d4d");
      }
      if (nextBtn && nextSvgPath) {
        nextBtn.classList.add("disabled");
        nextSvgPath.setAttribute("fill", "#4d4d4d");
      }
    } else {
      showSlides(slideIndex);
    }

    function showSlides(n) {
      if (n > slides.length) {
        slideIndex = slides.length;
      }
      if (n < 1) {
        slideIndex = 1;
      }

      for (let i = 0; i < slides.length; i++) {
        slides[i].classList.remove("active");
      }
      slides[slideIndex - 1].classList.add("active");

      // Update next button and path fill color
      if (nextBtn && nextSvgPath) {
        if (slideIndex === slides.length) {
          nextBtn.classList.add("disabled");
          nextSvgPath.setAttribute("fill", "#4d4d4d"); // Set arrow color to grey
        } else {
          nextBtn.classList.remove("disabled");
          nextSvgPath.setAttribute("fill", "#fff"); // Set arrow color to white
        }
      }

      // Update previous button and path fill color
      if (prevBtn && prevSvgPath) {
        if (slideIndex === 1) {
          prevBtn.classList.add("disabled");
          prevSvgPath.setAttribute("fill", "#4d4d4d"); // Set arrow color to grey
        } else {
          prevBtn.classList.remove("disabled");
          prevSvgPath.setAttribute("fill", "#fff"); // Set arrow color to white
        }
      }
    }

    // Next/previous controls
    window.plusSlides = function (n) {
      showSlides((slideIndex += n));
    };

    // Event listeners for the buttons
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        plusSlides(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        plusSlides(1);
      });
    }
  }

  // Initial function calls
  // handleMouseOver();
  hideSwipeIconOnInteraction();
  handleSlideshowNavigation();
  showSwipeIcon();
  // Event listeners
});
